import { Component } from '@angular/core';

@Component({
    selector: 'app-privacy-n-policy',
    imports: [],
    templateUrl: './privacy-n-policy.component.html',
    styleUrl: './privacy-n-policy.component.css'
})
export class PrivacyNPolicyComponent {

}
